<div class="bmark-summary__container">
  <!-- TOP BAR - Filter -->

  <div class="bfx-view-tool-bar" #topMenu>
    <div class="blotter_titlebar_interaction">
      <div class="blotter_filter_bar_container">
        @if(control.fwdRiskVisible){
        <bfx-risk-filter
          [activeFilter]="data.fwdRiskFilter"
          (activeFilterChange)="handleFwdFilterChanged($event)"
        ></bfx-risk-filter>
        <div class="filter-bar-separator"></div>
        }
        <div
          class="bfx-blotter-filter-bar blotter_filter_bar"
          [blotterInstance]="blotterInstance"
          [extendedTypeId]="extendedTypeId"
        ></div>
        <!-- [blotterInstance]="blotterInstance" -->
      </div>
      <div class="bfx-blotter-tools-container">
        <auto-hedge-status
          *ngIf="control.canUseCircuitBreaker"
          [on]="data.autoHedgingEnabled"
          [disabled]="false"
        ></auto-hedge-status>
        <div class="filter-bar-separator"></div>
        <bfx-quick-search
          class="bfx-quick-search"
          [(ngModel)]="searchValue"
          (ngModelChange)="onChangeSearchValue()"
        ></bfx-quick-search>
        <div class="blotter_titlebar_interaction_right">
          <bfx-icon-button
            size="sm"
            iconClass="icon_ion_filter_filled"
            (action)="showFilterManager($event)"
            title="Filter Manager"
          ></bfx-icon-button>
          <bfx-icon-button
            size="sm"
            iconClass="icon_ion_settings_filled"
            (action)="settingsMenu.toggle($event)"
            title="Settings"
          ></bfx-icon-button>
          <bmark-summary-settings-menu #settingsMenu></bmark-summary-settings-menu>
          <!-- </label> -->
        </div>
      </div>
    </div>
  </div>
  <!-- BODY -->
  <div class="bmark-summary__body">
    <!-- FIXING SELECTOR -->
    <div class="fixing-panels-container">
      <bmark-summary-fixings
        class="active-fixings-container"
        #activeFixings
        [style.height.px]="height"
        [style.minHeight.px]="minHeight"
        [displayedFixingsType]="BmarkFixingType.ACTIVE"
        [containerFixingsData]="fixingsData"
      ></bmark-summary-fixings>
      <div class="splitter-gutter">
        <div class="handle-container" (mousedown)="onResizeClick($event)">
          <div class="indicator"></div>
          <div class="indicator"></div>
        </div>
      </div>
      <bmark-summary-fixings
        class="recent-fixings-container"
        [style.minHeight.px]="minHeight"
        [displayedFixingsType]="BmarkFixingType.RECENT"
        [containerFixingsData]="fixingsData"
      ></bmark-summary-fixings>
      <div class="bmark-summary__content__monitor__actions-bar">
        <button
          pButton
          type="button"
          *ngIf="control.canViewHedgeOrders && control.bmRiskRouteEnabled && control.isTrader && control.manualRiskRouting"
          [label]="label.button.hedgeMonitorLabel"
          class="bfx-button-secondary-moderate bfx-button-sm bmark-summary__content__monitor__button"
          [disabled]="data.activeFixingData == null"
          (click)="activateHedgeMonitor()"
        ></button>
      </div>
    </div>
    <!--FIXING CONTENT-->
    <div class="bmark-summary__content">
      <!--Monitor-->
      <div
        [ngClass]="{'bmark-summary__content__monitor': true,
                'bmark-summary__content__monitor--five-tabs ': control.tabsNumber === 5,
                'bmark-summary__content__monitor--four-tabs ': control.tabsNumber === 4,
							 'bmark-summary__content__monitor--three-tabs ': control.tabsNumber === 3,
                'bmark-summary__content__monitor--two-tabs ': control.tabsNumber === 2,
							 'bmark-summary__content__monitor--one-tab ': control.tabsNumber === 1
 							}"
      >
        <div
          class="retrieving-label-container"
          *ngIf="retrievingFixingData; else retrievedFixingData"
        >
          <span>
            <i class="fa icon_ion_loading fa-spin"></i>
          </span>
          <span>{{label.retrievingOrders}}</span>
        </div>
        <ng-template #retrievedFixingData>
          <div>
            <span
              [title]="data.activeFixingTitle"
              class="bmark-summary__content__monitor__active-fixing"
              >{{data.activeFixingTitle}}
            </span>
          </div>
        </ng-template>
      </div>

      <!-- Tabs -->
      <div
        class="bmark-summary__content__tabs"
        [ngClass]="{
				'bmark-summary__content__tabs--view-filter-active': data.viewFilterType === BmarkSummaryViewFilterType.ACTIVE,
				'bmark-summary__content__tabs--view-filter-filled': data.viewFilterType === BmarkSummaryViewFilterType.FILLED
			}"
      >
        <p-tabView
          [activeIndex]="data.tabIndex"
          (onChange)="handleTabChange($event)"
          #tv
          styleClass="bfx-tabview"
        >
          @if(control.canViewSpotRisk) {
          <p-tabPanel [header]="label.tab.spotRiskLabel" #tabSpotRisk>
            <bmark-summary-spot-risk #subBlotterComponent [activeView]="data.activeTableView">
            </bmark-summary-spot-risk>
          </p-tabPanel>
          } @if (control.canViewFwdRisk){
          <p-tabPanel [header]="label.tab.fwdRiskLabel" #tabFwdRisk>
            <bmark-summary-fwd-risk
              #subBlotterComponent
              [activeView]="data.activeTableView"
              [riskFilter]="data.fwdRiskFilter"
            >
            </bmark-summary-fwd-risk>
          </p-tabPanel>
          }

          <p-tabPanel
            [header]="label.tab.clientOrdersLabel"
            #tabClientOrders
            *ngIf="control.canViewClientOrders"
          >
            <!--  [selected]="true" -->
            <bmark-summary-client-orders #subBlotterComponent [activeView]="data.activeTableView">
            </bmark-summary-client-orders>
          </p-tabPanel>
          <p-tabPanel
            [header]="label.tab.hedgeOrdersLabel"
            #tabHedgeOrders
            *ngIf="control.canViewHedgeOrders"
          >
            <bmark-summary-hedge-orders #subBlotterComponent [activeView]="data.activeTableView">
            </bmark-summary-hedge-orders>
          </p-tabPanel>
          <p-tabPanel
            [header]="label.tab.auditLabel"
            #tabAudit
            *ngIf="control.canViewBenchmarkAudit"
          >
            <bfx-fixing-blotter-audit #subBlotterComponent [activeView]="data.activeTableView">
            </bfx-fixing-blotter-audit>
          </p-tabPanel>
        </p-tabView>
      </div>
      <!--Bottom Bar - Actions -->
      <div
        class="bmark-summary__content__bottom-bar"
        #bottomBar
        [title]="bottomBarTitle"
        [ngClass]="{
          'bmark-summary__content__bottom-bar--view-filter-active': data.viewFilterType === BmarkSummaryViewFilterType.ACTIVE,
          'bmark-summary__content__bottom-bar--view-filter-filled': data.viewFilterType === BmarkSummaryViewFilterType.FILLED
        }"
      >
        <ng-container *ngTemplateOutlet="mdBottomBar"></ng-container>
        <ng-template #mdBottomBar>
          <div
            class="bmark-summary__content__bottom-bar__view-filter bfx-segmented-group-container-sm"
            [ngClass]="{
                        'bfx-segmented-group-container-subtle-disabled':data.activeFixingData == null,
                        'bfx-segmented-group-container-subtle-enabled':data.activeFixingData != null
                      }"
            *ngIf="control.typeFilterVisible"
            [disabled]="data.activeFixingData == null"
          >
            <button
              class="bfx-segmented-control-sm"
              [ngClass]="{
                          'bfx-segmented-control-subtle-unselected-sm':data.viewFilterType !== BmarkSummaryViewFilterType.ALL,
                          'bfx-segmented-control-subtle-selected-sm':data.viewFilterType == BmarkSummaryViewFilterType.ALL
                        }"
              [disabled]="data.activeFixingData == null"
              (click)="selectViewFilterAll()"
            >
              <span class="label-primary">{{label.button.viewFilter.all}}</span>
            </button>
            <button
              class="bfx-segmented-control-sm"
              [ngClass]="{
                      'bfx-segmented-control-subtle-unselected-sm':data.viewFilterType !== BmarkSummaryViewFilterType.ACTIVE,
                      'bfx-segmented-control-subtle-selected-sm':data.viewFilterType == BmarkSummaryViewFilterType.ACTIVE
                    }"
              [disabled]="data.activeFixingData == null"
              (click)="selectViewFilterActive()"
            >
              <span class="label-primary">{{label.button.viewFilter.active}}</span>
            </button>
            <button
              class="bfx-segmented-control-sm"
              [ngClass]="{
                      'bfx-segmented-control-subtle-unselected-sm':data.viewFilterType !== BmarkSummaryViewFilterType.FILLED,
                      'bfx-segmented-control-subtle-selected-sm':data.viewFilterType == BmarkSummaryViewFilterType.FILLED
                    }"
              [disabled]="data.activeFixingData == null"
              (click)="selectViewFilterFilled()"
            >
              <span class="label-primary">{{label.button.viewFilter.filled}}</span>
            </button>
          </div>
          <div style="flex: 1 1 auto"></div>
          <div
            class="bmark-summary__content__bottom-bar__content bfx-segmented-group-container-sm"
            [ngClass]="{
                    'bfx-segmented-group-container-subtle-disabled':data.activeFixingData == null,
                    'bfx-segmented-group-container-subtle-enabled':data.activeFixingData != null
                  }"
            *ngIf="control.dealtRiskVisible"
            [disabled]="data.activeFixingData == null"
          >
            <button
              class="bfx-segmented-control-sm"
              [ngClass]="{
                        'bfx-segmented-control-subtle-unselected-sm':data.activeTableView === BmarkClientOrdersBlotterMode.RISK,
                        'bfx-segmented-control-subtle-selected-sm':data.activeTableView === BmarkClientOrdersBlotterMode.DEALT
                      }"
              *ngIf="control.dealtRiskVisible"
              type="button"
              [disabled]="data.activeFixingData == null"
              (click)="activateDealtView()"
            >
              <span class="label-primary">{{label.button.dealtViewLabel}}</span>
            </button>
            <button
              class="bfx-segmented-control-sm"
              [ngClass]="{
                        'bfx-segmented-control-subtle-unselected-sm':data.activeTableView === BmarkClientOrdersBlotterMode.DEALT,
                        'bfx-segmented-control-subtle-selected-sm': data.activeTableView === BmarkClientOrdersBlotterMode.RISK
                      }"
              *ngIf="control.dealtRiskVisible"
              type="button"
              [label]="label.button.riskViewLabel"
              [disabled]="data.activeFixingData == null"
              (click)="activateRiskView()"
            >
              <span class="label-primary">{{label.button.riskViewLabel}}</span>
            </button>
          </div>
          <button
            *ngIf="control.copyClipboardVisible"
            pButton
            class="bfx-button-secondary-bold"
            type="button"
            [disabled]="data.activeFixingData == null"
            (click)="copyToClipboard()"
            [label]="label.button.copyToClipboard"
          ></button>
        </ng-template>
      </div>
    </div>
  </div>
</div>
